import {
  ASSISTANT_BYO_CLAUDE_MONTHLY_PRICE,
  ASSISTANT_FLAT_MONTHLY_PRICE,
  PRIME_AI_MONTHLY_TOKEN_CAP_DEFAULT,
} from "@prime-assistant/shared";

/** e.g. 3_000_000 → "3M". */
export const MONTHLY_AI_TOKENS_LABEL = `${Math.round(PRIME_AI_MONTHLY_TOKEN_CAP_DEFAULT / 100_000) / 10}M`;

export const FLAT_MONTHLY_PRICE_CAD = ASSISTANT_FLAT_MONTHLY_PRICE;
export const BYO_CLAUDE_MONTHLY_PRICE_CAD = ASSISTANT_BYO_CLAUDE_MONTHLY_PRICE;

/** Shared marketing copy: hosted Pro plans and the My Claude platform plan. */
export const PRO_ACCOUNT_NOTE =
  "Pro flat and Pro per-use cover Emma plus Google Cloud, Modal, and our self-hosted servers. My Claude is a separate $40 CAD/month platform subscription — you bring your Anthropic key and Anthropic bills model usage.";

export const pricingPlans = [
  {
    id: "assistant" as const,
    name: "Pro — flat monthly",
    price: `$${FLAT_MONTHLY_PRICE_CAD}`,
    period: "/month per broker",
    blurb: `One flat $${FLAT_MONTHLY_PRICE_CAD} CAD bill per broker each month for chat and automated assistants. Includes up to ${MONTHLY_AI_TOKENS_LABEL} AI tokens a month (Claude + Prime AI combined) — we'll let you know at 80%.`,
    highlights: [
      `${MONTHLY_AI_TOKENS_LABEL} AI tokens included each month`,
      "Scheduled automated assistants + email approvals",
      "Velocity, Gmail & Drive connections",
      "Optional: switch to your own Claude key anytime",
      "Pro covers Google Cloud, Modal & hosting infra",
    ],
    cta: "Sign up — flat Pro",
    featured: true,
  },
  {
    id: "assistant_usage" as const,
    name: "Pro — pay per use",
    price: "Metered",
    period: " AI usage",
    blurb:
      "Same Prime Pro workspace, billed for the hosted AI you use. You still need a Pro account — per-use is how AI is charged, not a free tier without infrastructure.",
    highlights: [
      "Everything in flat Pro (tools, automated assistants, connectors)",
      "Pay for hosted AI as you go",
      "Usage & bill visible in-app",
      "Pro account required for Google Cloud, Modal & hosting",
      "Optional connector for Claude Desktop / Cursor",
    ],
    cta: "Sign up — per-use Pro",
    featured: false,
  },
  {
    id: "byo_claude" as const,
    name: "My Claude",
    price: `$${BYO_CLAUDE_MONTHLY_PRICE_CAD}`,
    period: "/month",
    blurb: `Bring your own Anthropic Claude key. $${BYO_CLAUDE_MONTHLY_PRICE_CAD} CAD/month covers the Prime workspace, tools, automated assistants, and connectors. Claude model usage bills to Anthropic — not included in this fee.`,
    highlights: [
      `$${BYO_CLAUDE_MONTHLY_PRICE_CAD} CAD platform fee every month`,
      "Your Anthropic key powers chat & automated assistants",
      "Model usage billed by Anthropic",
      "Same Velocity, Gmail, Drive & automated assistant workflows",
      "No Emma included on this plan",
    ],
    cta: "Sign up — My Claude",
    featured: false,
  },
] as const;
